import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CATEGORIES } from '../utils/constants';
import { CategoryCard } from '../components/CategoryCard';
import { Header } from '../components/Header';
import { RequestHistory } from '../components/RequestHistory';
import { LanguageModal } from '../components/LanguageModal';
import { ShieldCheck, BadgeDollarSign, CheckCircle2 } from 'lucide-react';
export function Landing() {
  const navigate = useNavigate();
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showHeaderPulse, setShowHeaderPulse] = useState(false);
  useEffect(() => {
    // Check if user has seen the language modal
    const hasSeenModal = localStorage.getItem('language-modal-shown');
    if (!hasSeenModal) {
      // Small delay for better UX
      const timer = setTimeout(() => {
        setShowLanguageModal(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleCategoryClick = (id: string) => {
    navigate(`/request?category=${id}`);
  };
  const handleLanguageSelect = (code: string) => {
    localStorage.setItem('app-language', code);
    localStorage.setItem('language-modal-shown', 'true');
    window.dispatchEvent(new Event('language-change'));
    setShowLanguageModal(false);
    // Trigger header pulse animation to show where to change it later
    setTimeout(() => {
      setShowHeaderPulse(true);
      // Stop pulsing after 4 seconds
      setTimeout(() => setShowHeaderPulse(false), 4000);
    }, 500);
  };
  const handleCloseModal = () => {
    localStorage.setItem('language-modal-shown', 'true');
    setShowLanguageModal(false);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-122">
      <Header showPulse={showHeaderPulse} data-id="element-123" />

      <LanguageModal isOpen={showLanguageModal} onClose={handleCloseModal} onSelectLanguage={handleLanguageSelect} data-id="element-124" />

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-8" data-id="element-125">
        <div className="text-center mb-8" data-id="element-126">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-127">
            What do you need help with?
          </h2>
          <p className="text-gray-600" data-id="element-128">Select a service to get started</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-id="element-129">
          {CATEGORIES.map(category => <CategoryCard key={category.id} id={category.id} name={category.name} icon={category.icon} disabled={category.disabled} onClick={handleCategoryClick} data-id="element-130" />)}
        </div>

        <RequestHistory data-id="element-131" />

        <div className="mt-12 p-6 bg-teal-50 rounded-2xl border border-teal-100 text-center" data-id="element-132">
          <h3 className="text-lg font-semibold text-teal-900 mb-2" data-id="element-133">
            Why choose Hands?
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4 text-sm text-teal-800" data-id="element-134">
            <div className="flex flex-col items-center" data-id="element-135">
              <ShieldCheck className="w-8 h-8 mb-2 fill-teal-600 text-teal-600" data-id="element-136" />
              <span className="font-bold block mb-1" data-id="element-137">Verified Pros</span>
              <span className="opacity-80" data-id="element-138">
                All service providers are vetted
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-139">
              <BadgeDollarSign className="w-8 h-8 mb-2 fill-teal-600 text-teal-600" data-id="element-140" />
              <span className="font-bold block mb-1" data-id="element-141">Fair Pricing</span>
              <span className="opacity-80" data-id="element-142">
                Transparent quotes, no hidden fees
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-143">
              <CheckCircle2 className="w-8 h-8 mb-2 fill-teal-600 text-teal-600" data-id="element-144" />
              <span className="font-bold block mb-1" data-id="element-145">
                Satisfaction Guarantee
              </span>
              <span className="opacity-80" data-id="element-146">
                We ensure the job is done right
              </span>
            </div>
          </div>
        </div>
      </main>

      <footer className="bg-white border-t border-gray-100 py-6 text-center text-sm text-gray-400" data-id="element-147">
        <p data-id="element-148">
          &copy; {new Date().getFullYear()} Hands Marketplace. All rights
          reserved.
        </p>
      </footer>
    </div>;
}